import React from 'react';

import { Box } from '@chakra-ui/react';
import { PerformanceReviewGraph } from 'screens/performanceReview/LandingPage/PerformanceReviewGraphV1';

export const apiToLineChartDataTransformer = ({ nodes }) => {
  const linesInfo = [];
  const lineChartNodes = [];

  nodes.forEach(({ employee, dataSeries }) => {
    linesInfo.push({
      key: `${employee.id}-OverallScore`,
      name: `${employee.name}`,
      color: '#4657AE',
    });

    dataSeries.forEach(({ reviewCycle, score }) => {
      const { id, name } = reviewCycle;

      const existingNode = lineChartNodes.find((node) => node.reviewCycleId === id);

      // skip the point if OVERALL score is not present
      if (score.OVERALL === undefined || score.OVERALL === null) {
        return;
      }

      if (existingNode) {
        existingNode[`${employee.id}-OverallScore`] = score.OVERALL;
        existingNode[`${employee.id}-employeeId`] = employee.id;
        existingNode[`${employee.id}-employee`] = employee;
        existingNode.tooltipData.push({
          employee,
          score,
        });
      } else {
        const lineChartNode = {
          [`${employee.id}-employeeId`]: employee.id,
          [`${employee.id}-employee`]: employee,
          reviewCycleId: id,
          reviewCycle: name,
          score,
          [`${employee.id}-OverallScore`]: score.OVERALL,
          tooltipData: [
            {
              employee,
              score,
            },
          ],
        };
        lineChartNodes.push(lineChartNode);
      }
    });
  });

  const performanceReviewData = {
    ratingMap: {
      '1': '1.00',
      '2': '2.00',
      '3': '3.00',
      '4': '4.00',
      '5': '5.00',
    },
    reviewRatingDetailsResponseList: lineChartNodes,

    dataMap: {
      OVERALL: 'Overall Performance Score',
      PERFORMANCE: 'Goal score',
      POTENTIAL: 'Competency score',
      QNA: 'Overall questions score',
    },
  };

  const yAxisTicks = ['1', '2', '3', '4', '5'];

  return { performanceReviewData, linesInfo, yAxisTicks };
};

export const PerformanceReviewGraphV1Wrapper = ({ lineChartData }) => {
  const { performanceReviewData, linesInfo, yAxisTicks } = lineChartData;

  return (
    <Box height="100%">
      {performanceReviewData.reviewRatingDetailsResponseList.length !== 0 && (
        <Box h="100%" mt={4}>
          <PerformanceReviewGraph
            performanceReviewData={performanceReviewData}
            linesInfo={linesInfo}
            yAxisTicks={yAxisTicks}
            tooltipVersion="v1"
          />
        </Box>
      )}
    </Box>
  );
};
